export default __webpack_public_path__ + "static/media/IMG-20241005-WA0039.297843ae.jpg";